export async function postImport(
  endpoint: string,
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) {
  const controller = new AbortController();
  const timeoutId = options?.timeoutMs
    ? setTimeout(() => controller.abort(), options.timeoutMs)
    : null;

  try {
    const response = await fetch(process.env.REACT_APP_API_URL + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
      signal: controller.signal,
    });

    if (!response.ok) {
      const text = await response.text();
      let body: any = text;
      try {
        body = JSON.parse(text);
      } catch (_) {
        // Keep plain-text API errors as-is.
      }
      const message =
        body?.error?.message || body?.message || text || `Import failed (${response.status})`;
      const error: any = new Error(message);
      error.response = { status: response.status, data: body };
      throw error;
    }

    const metadataHeader = response.headers.get("X-Metadata");
    let metadata = null;
    if (metadataHeader) {
      try {
        metadata = JSON.parse(metadataHeader);
      } catch (_) {
        metadata = null;
      }
    }

    return { blob: await response.blob(), metadata };
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}
